/**
 * Overlay de tela cheia para feedback de upload (bloqueia interação).
 */
export default function MobileUploadOverlay({
  open,
  phase = "uploading",
  percent = 0,
  fileName = "",
}) {
  if (!open) return null;

  const clamped = Math.max(0, Math.min(100, Number(percent) || 0));
  const phaseLabel =
    phase === "preparing"
      ? "Preparando arquivo…"
      : phase === "finalizing"
        ? "Finalizando…"
        : "Enviando anexo…";

  const showBar = phase === "uploading" || phase === "finalizing";
  const barPercent = phase === "finalizing" ? 100 : clamped;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 px-6"
      role="alertdialog"
      aria-modal="true"
      aria-busy="true"
      aria-labelledby="mobile-upload-title"
      data-testid="mobile-upload-overlay"
    >
      <div className="w-full max-w-sm rounded-2xl border border-primary bg-mgs-bg p-5 shadow-xl">
        <h2
          id="mobile-upload-title"
          className="text-base font-semibold text-laranjinha"
        >
          {phaseLabel}
        </h2>
        {fileName ? (
          <p className="mt-1 truncate text-sm text-laranjinha/60" title={fileName}>
            {fileName}
          </p>
        ) : null}
        {showBar ? (
          <div className="mt-4">
            <div
              className="h-2 overflow-hidden rounded-full bg-monao"
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={barPercent}
              aria-label="Progresso do upload"
            >
              <div
                className="h-full rounded-full bg-primary transition-[width] duration-150 ease-out"
                style={{ width: `${barPercent}%` }}
              />
            </div>
            <p className="mt-2 text-center text-sm font-medium text-laranjinha">
              {phase === "finalizing" ? "Quase lá…" : `${barPercent}%`}
            </p>
          </div>
        ) : (
          <div className="mt-4 flex justify-center" aria-hidden="true">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-monao border-t-primary" />
          </div>
        )}
      </div>
    </div>
  );
}
